'use client'

import { useEffect, useState } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { redirectToPageInNewTab } from '@marketplace-web/browser/browser-navigation-util'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'
import {
  clickEvent,
  getDownloadLabelUrl,
} from '@marketplace-web/conversation-shipping/conversation-shipping-data'

type Props = ConversationActionProps

const DownloadShippingLabel = ({ title, primary, size, theme, inverse }: Props) => {
  const { track } = useTracking()

  const { conversation } = useConversationContext()

  const transactionId = conversation?.transaction?.id
  const shipmentId = conversation?.transaction?.shipment?.id

  const [labelUrl, setLabelUrl] = useState<string>()

  useEffect(() => {
    const fetchLabelUrl = async () => {
      if (!shipmentId) return

      const response = await getDownloadLabelUrl(shipmentId)

      if ('errors' in response) {
        return
      }

      const { label_url } = response

      setLabelUrl(label_url)
    }

    fetchLabelUrl()
  }, [shipmentId])

  function trackClick() {
    const targetDetails = {
      transaction_id: transactionId,
    }

    track(
      clickEvent({
        target: 'download_shipping_label',
        targetDetails: JSON.stringify(targetDetails),
      }),
    )
  }

  function handleClick() {
    if (!labelUrl) return

    trackClick()

    redirectToPageInNewTab(labelUrl)
  }

  return (
    <ConversationActionButton
      primary={primary}
      text={title}
      size={size}
      theme={theme}
      inverse={inverse}
      onClick={handleClick}
      testId="download-shipping-label-button"
    />
  )
}

export default DownloadShippingLabel
